import { Map as map } from 'immutable';
const C = require("../constants");

function TaxSelectReducer(state = map(), action) {
    switch (action.type) {
        case C.TAX_SELECT:
            return action.data;
        default:
            return state;
    }
};

export default TaxSelectReducer;


// WEBPACK FOOTER //
// ./src/reducers/TaxSelectReducer.js